import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddHospitalComponent } from '../../modals/add-hospital/add-hospital.component';
import { Site, Admin } from '@app-models/site';
import { SiteService } from '@app-services/site.service';
import { EditUserSettingComponent } from '../../modals/edit-user-setting/edit-user-setting.component';
import { ChangePasswordComponent } from '../../modals/change-password/change-password.component';

import { AppURL } from '../../../app.url';
import { ActivatedRoute, Router, Event, RoutesRecognized, ActivatedRouteSnapshot, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { TextDialogComponent } from '../text-dialog/text-dialog.component';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {
  @Output()
  homeBtnClick = new EventEmitter();
  selectedSiteId: string;
  sites: Site[] = [];
  admin: Admin;
  Url = AppURL;
  eventSub: Subscription;
  editUserDialogRef: MatDialogRef<EditUserSettingComponent>;
  passwordDialogRef: MatDialogRef<ChangePasswordComponent>;

  keyDescOrder = (a: KeyValue<any, Site>, b: KeyValue<any, Site>): number => {
    // const aIsNum = /^\d+$/.test(a.value.displayId);
    // const bIsNum = /^\d+$/.test(b.value.displayId);
    // console.log(a.value.displayId, aIsNum);
    // if (aIsNum === bIsNum) {
    return a.value.displayId < b.value.displayId ? -1 : (b.value.displayId < a.value.displayId ? 1 : 0);
    // } else {
      // return aIsNum ? -1 : 1;
    // }
  }

  constructor(
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private ss: SiteService,
    private as: AuthService,
    private auth: AuthService) { }

  ngOnInit() {
    if (this.route.firstChild) {
      this.eventSub = this.route.firstChild.params.subscribe(
        (params: Params) => {
          this.selectedSiteId = params.siteId;
        }
      );
    }
    this.router.events.subscribe(
      (value: Event) => {
        if (value instanceof RoutesRecognized) {
          if (value.state.root.firstChild && value.state.root.firstChild.firstChild) {
            const childRoute: ActivatedRouteSnapshot = value.state.root.firstChild.firstChild;
            this.selectedSiteId = childRoute.params.siteId;
          }
        }
      }
    );
    this.initSites();
    this.ss.imageUpdated.subscribe((site: Site) => {
      const s = this.sites.find((element: Site) => site.id === element.id);
      if (s) {
        const ts = Math.round((new Date()).getTime() / 1000);
        const i = s.logoUrl.indexOf('&ts');
        if (i !== -1) {
          s.logoUrl = s.logoUrl.substring(0, i);
        }
        s.logoUrl = s.logoUrl + '&ts=' + ts;
        this.cdRef.detectChanges();
      }
    });
  }

  initSites() {
    this.ss.getSiteList().then(
      (sites: Site[]) => {
        this.sites = sites;
        this.ss.currentSiteList = sites;
        this.cdRef.detectChanges();
      }
    );
    this.ss.getCurrentAdmin().then(
      (admin: Admin) => {
        // console.log(this.as.getAuthenState())
        if (!admin.id) {
          admin.id = this.as.getAuthenState().uid;
        }
        this.admin = admin;
        this.ss.siteAdmin = admin;
        this.cdRef.detectChanges();
      }
    ).catch((reason) => {
      const textDialog = this.dialog.open(TextDialogComponent, {
        width: '300px',
        data: reason
      });
      textDialog.afterClosed().subscribe(
        (value) => {
          this.as.signOutUser();
        }
      );
    });
  }

  ngOnDestroy() {
    this.sites = null;
    this.admin = null;
    if (this.eventSub) {
      this.eventSub.unsubscribe();
    }
  }

  onHomeBtnClick() {
    this.homeBtnClick.emit();
  }

  openEditUser() {
    const currentAdmin = this.admin;
    this.editUserDialogRef = this.dialog.open(EditUserSettingComponent, {
      width: '450px',
      height: '380px',
      data: { currentAdmin },
    });
  }

  openChangePassword() {
    const userEmail = this.admin.email;
    this.passwordDialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '450px',
      height: '380px',
      data: { userEmail },
    });
  }

  signOut() {
    this.auth.signOutUser();
  }

  openDialog() {
    const site = this.ss.newSite();
    const dialogRef = this.dialog.open(AddHospitalComponent, {
      width: '480px',
      data: site
    });
    dialogRef.afterClosed().subscribe(
      (submit: boolean) => {
        if (submit) {
          this.initSites();
        }
      }
    );
  }
}
